// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__vZKhF","title":"Images45_title__jbwxb","images":"Images45_images__J378g"};